import { startDiwaliMouse, endDiwaliMouse } from '../../misc/diwali';
import { Harpic, checkDocument } from '../../customLib';

let diwaliMouse = false;

if (checkDocument()) {
	if (!!window.localStorage.getItem('diwaliCursor')) {
		try {
			diwaliMouse = JSON.parse(
				Harpic(
					decodeURIComponent(
						window.localStorage.getItem('diwaliCursor')
					)
				)
			);
		} catch (err) {
			console.log(err);
		}
	}
}

export const initDiwaliThingies = {
	diwaliMouse,
};

const startDiwaliCursor = () => {
	startDiwaliMouse();
	if (checkDocument()) {
		window.localStorage.setItem('diwaliCursor', true);
	}
	return {
		diwaliMouse: true,
	};
};

const stopDiwaliCursor = () => {
	endDiwaliMouse();
	if (checkDocument()) {
		window.localStorage.setItem('diwaliCursor', false);
	}
	return {
		diwaliMouse: false,
	};
};

// ---------------------------------------------------

export const diwaliActions = {
	__startDiwaliThingy: startDiwaliCursor,
	__stopDiwaliThingy: stopDiwaliCursor,
};
